<template>
	<v-footer class="bg-teal-lighten-3 text-center d-flex flex-column footer pt-">
		<div>
			<v-btn v-for="item in socials" :key="item.href" class="mx-4" variant="text" @click="onClick(item.href)">
				<v-icon v-if="item.icon.startsWith('mdi-')">{{ item.icon }}</v-icon>
				<img v-else :src="item.icon" />
			</v-btn>
		</div>
		<div>©{{ new Date().getFullYear() }} — <strong>LiveReader</strong></div>
	</v-footer>
</template>

<script setup lang="ts">
const socials = [
	{
		icon: "mdi-linkedin",
		href: "https://www.linkedin.com/company/livereader-gmbh/",
	},
	{
		icon: "/discord.svg",
		href: "https://discord.gg/M2dBMRcXTg",
	},
	{
		icon: "mdi-github",
		href: "https://github.com/LiveReader",
	},
];

function onClick(href: string) {
	window.open(href, "_blank");
}
</script>

<style scoped lang="scss">
.footer {
	background-color: #780100 !important;
}
</style>
